// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Use environment variables for production safety
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

// Create client with Edge Functions support
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  global: {
    headers: {
      'Accept': 'application/json',
    },
  },
  // Only enable debug mode in development
  debug: import.meta.env.DEV,
});

// Remove console log
// console.log('===== SUPABASE CLIENT SETUP COMPLETE =====');

// Add error handler to help diagnose issues - only log critical errors
if (import.meta.env.DEV) {
  // Listen for Supabase-related errors
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && typeof event.reason === 'object') {
      const error = event.reason;
      // Only log critical errors, not common operational errors
      if (
        error.message && 
        (error.message.includes('supabase') && error.message.includes('authentication')) ||
        (error.message.includes('REST') && error.message.includes('failed')) ||
        (error.message.includes('HTTP') && error.status >= 500)
      ) {
        console.error('Critical Supabase Error:', error);
      }
    }
  });
}